/* 前台真实可见分段；独立声明兼容 data-ph，不依赖或转发旧 SDK 的对象。 */
(function () {
  'use strict';
  var api = window.__ga4Journey;
  if (!api) return;
  var states = new Map();
  var accordions = new Map(), scrollStates = new WeakMap();
  var componentSelector = '[data-ga4-component]:not(template), [data-ph-component]';
  var declarations = new WeakMap();
  function markControls() {
    // 仅适配明确的营销区块和评论操作控件，按既有四件套声明；不采集评论正文或表单输入。
    document.querySelectorAll('.richtextfornewdesign, [id^="BrandStory-"], [id^="FeatureRowsStatic-"], [id^="FeatureCards-"], .gift-landing, .pdp-occasion, [id^="shopify-section-"]').forEach(function (root) {
      var marker = root.querySelector('template[data-ga4-component-owner="section"]');
      if (root.matches('[id^="shopify-section-"]') && (!marker || !/^(gift_|featured_category_carousel)/.test(marker.dataset.ga4Component))) return;
      var name = root.dataset.ga4Component || root.dataset.phComponent || (marker && marker.dataset.ga4Component) || 'marketing_content';
      root.querySelectorAll('a[href]').forEach(function (link, index) {
        if (link.hasAttribute('data-ph-action') || link.hasAttribute('data-ga4-product-card') || link.closest('[data-ga4-product-card]')) return;
        link.setAttribute('data-ph-component', name);
        link.setAttribute('data-ph-id', (root.id || name) + ':link:' + (index + 1));
        link.setAttribute('data-ph-action', 'link_click');
        link.setAttribute('data-ph-content-name', link.textContent.replace(/\s+/g, ' ').trim().slice(0, 80) || 'image_link');
      });
    });
    document.querySelectorAll('.jdgm-review-widget, .jdgm-rev-widg').forEach(function (root) {
      [['.jdgm-write-rev-link', 'write_review_click'], ['.jdgm-paginate__page', 'review_pagination_click'], ['.jdgm-sort-dropdown', 'review_filter_click'], ['.jdgm-rev__thumb-btn', 'review_helpful_click']].forEach(function (entry) {
        root.querySelectorAll(entry[0]).forEach(function (control, index) {
          if (control.hasAttribute('data-ph-action')) return;
          control.setAttribute('data-ph-component', 'review_widget');
          control.setAttribute('data-ph-id', (root.id || 'review_widget') + ':' + entry[1] + ':' + (index + 1));
          control.setAttribute('data-ph-action', entry[1]);
          control.setAttribute('data-ph-content-name', entry[1]);
        });
      });
    });
  }
  function declaration(element) { return declarations.get(element) || element; }
  function independent(element) { return declaration(element).hasAttribute('data-ga4-component'); }
  function componentName(element) { return declaration(element).getAttribute('data-ga4-component') || element.getAttribute('data-ph-component'); }
  function redundantWrapper(element, elements) {
    if (element.hasAttribute('data-ph-action')) return false;
    var name = componentName(element);
    // 明确的 GA4 内容根优先于旧脚本补出的同名内外层，独立 CTA 和显式实例保留。
    if (!independent(element)) {
      var parent = element.parentElement;
      while (parent) {
        if (independent(parent) && componentName(parent) === name && !parent.hasAttribute('data-ph-action')) return true;
        parent = parent.parentElement;
      }
      if (elements.some(function (child) { return child !== element && element.contains(child) && independent(child) && !child.hasAttribute('data-ph-action') && componentName(child) === name; })) return true;
    }
    // 商品表单的 name="id" 控件会遮蔽 form.id，属性读取不受命名控件影响。
    return (element.getAttribute('id') || '').startsWith('shopify-section-') && elements.some(function (child) {
      return child !== element && element.contains(child) && !child.hasAttribute('data-ph-action') && componentName(child) === name;
    });
  }
  function components() {
    var elements = Array.from(document.querySelectorAll(componentSelector));
    declarations = new WeakMap();
    document.querySelectorAll('template[data-ga4-component-owner][data-ga4-component]').forEach(function (marker) {
      var owner = marker.closest(marker.dataset.ga4ComponentOwner === 'section' ? '[id^="shopify-section-"]' : '.shopify-block');
      if (!owner || owner.hasAttribute('data-ga4-component')) return;
      declarations.set(owner, marker);
      if (elements.indexOf(owner) < 0) elements.push(owner);
    });
    return elements.filter(function (el) { return !redundantWrapper(el, elements); }).sort(function (a, b) {
      return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });
  }
  function fields(element, elements) {
    var root = element.closest('[id^="shopify-section-"]');
    var declared = declaration(element), declaredSection = declared.closest('[data-ga4-section-id]');
    var scope = declaredSection ? declaredSection.getAttribute('data-ga4-section-id') : (root ? root.getAttribute('id').replace(/^shopify-section-/, '') : '');
    var name = componentName(element);
    var id = declared.getAttribute('data-ga4-component-id') || element.getAttribute('data-ph-component-id') || element.getAttribute('data-ph-id') || element.getAttribute('id') || name;
    var key = scope && id.indexOf(scope) < 0 ? scope + ':' + id : id;
    var position = (elements || components()).indexOf(element) + 1;
    return { component_name: name, component_key: key, component_id: id, component_position: position,
      section_id: scope ? 'shopify-section-' + scope : 'unassigned', measurement_version: 'viewport-half-v1' };
  }
  function end(state, reason) {
    if (state.started === null) return;
    var duration = Math.round(performance.now() - state.started);
    state.started = null;
    if (duration > 0) api.emit('component_dwell', Object.assign({}, state.fields, {
      impression_id: state.impression, segment_index: state.segment,
      dwell_time_ms: duration, dwell_end_reason: reason
    }));
  }
  function start(state) {
    if (!displayed(state.element)) { end(state, 'visibility_changed'); state.impression = null; return; }
    if (!api.isAllowed() || document.visibilityState === 'hidden' || !state.visible || state.started !== null) return;
    if (!state.impression) {
      state.impression = api.uuid();
      api.emit('component_view', Object.assign({}, state.fields, { impression_id: state.impression }));
      if (state.element.matches('[data-cart-reward-bar]')) {
        var d = state.element.dataset;
        api.emit('cart_reward_bar_view', { component_key: state.fields.component_key, impression_id: state.impression,
          cart_surface: state.element.closest('#CartDrawer') ? 'drawer' : 'page', currency: d.currency,
          reward_subtotal: Number(d.rewardSubtotal) / 100, cart_item_count: Number(d.cartItemCount),
          discount_percent: Number(d.discountPercent), discount_item_count: Number(d.discountCount),
          free_shipping_count: Number(d.freeShippingCount), free_shipping_minimum: Number(d.freeShippingMinimum) / 100,
          free_gift_enabled: d.freeGiftEnable === 'true', free_gift_count: Number(d.freeGiftCount), reward_threshold_count: Number(d.maxThreshold) });
      }
    }
    state.segment++;
    state.started = performance.now();
  }
  function displayed(element) {
    if (!element.isConnected || !element.getClientRects().length) return false;
    for (var node = element; node && node.nodeType === 1; node = node.parentElement) {
      var style = getComputedStyle(node);
      if (node.hidden || node.inert || node.getAttribute('aria-hidden') === 'true' || style.display === 'none' ||
        style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
    }
    return true;
  }
  var observer = window.IntersectionObserver && new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var state = states.get(entry.target);
      if (!state) return;
      var rect = entry.boundingClientRect, visible = entry.intersectionRect;
      // 长组件按其与视口较小面积的一半判断；规则随事件保留版本。
      var required = Math.min(rect.height, window.innerHeight) * Math.min(rect.width, window.innerWidth) * 0.5;
      state.visible = entry.isIntersecting && required > 0 && visible.width * visible.height >= required;
      if (state.visible) start(state);
      else { end(state, 'viewport_exit'); state.impression = null; }
    });
  }, { threshold: Array.from({ length: 101 }, function (_, i) { return i / 100; }) });
  function scan() {
    markControls();
    if (!observer) return; // 不将无 IO 支持当作曝光。
    var elements = components();
    states.forEach(function (state, element) {
      if (elements.indexOf(element) < 0) { end(state, 'removed'); observer.unobserve(element); states.delete(element); }
    });
    elements.forEach(function (element) {
      var next = fields(element, elements), state = states.get(element);
      if (state) {
        if (state.fields.component_key !== next.component_key || state.fields.component_name !== next.component_name) {
          end(state, 'metadata_changed'); state.impression = null; state.segment = 0;
        }
        state.fields = next; start(state); return;
      }
      states.set(element, { element: element, fields: next, started: null, visible: false, impression: null, segment: 0 });
      observer.observe(element);
    });
    accordions.forEach(function (state, element) {
      if (!element.isConnected) { endAccordion(element, state, 'removed'); accordions.delete(element); }
    });
  }
  function accordionFields(element) {
    var root = element.closest('[id^="shopify-section-"]'), group = element.closest('.product-main, [data-section-type="product"], product-hot-reload') || root;
    var index = group ? Array.from(group.querySelectorAll('details')).indexOf(element) + 1 : 1;
    var key = (root ? root.id : 'product') + ':accordion:' + index;
    return { component_name: 'product_accordion', component_key: key, component_id: key, section_id: root ? root.id : 'unassigned',
      measurement_version: 'foreground-open-v1', content_index: index, interaction_type: 'accordion' };
  }
  function endAccordion(element, state, reason) {
    if (state.start === null) return;
    api.emit('component_interaction', Object.assign(accordionFields(element), { action: 'accordion_dwell', content_name: reason, open_duration_ms: Math.round(performance.now() - state.start) }));
    state.start = null;
  }
  document.addEventListener('toggle', function (event) {
    var element = event.target;
    if (!element.matches('details') || !element.closest('.product-main, [data-section-type="product"], product-hot-reload') || !api.isAllowed()) return;
    var state = accordions.get(element) || { start: null };
    accordions.set(element, state);
    if (!element.open) endAccordion(element, state, 'closed');
    else if (document.visibilityState !== 'hidden') state.start = performance.now();
    api.emit('component_interaction', Object.assign(accordionFields(element), { action: element.open ? 'accordion_open' : 'accordion_close' }));
  }, true);
  document.addEventListener('scroll', function (event) {
    var element = event.target;
    if (!api.isAllowed() || document.visibilityState === 'hidden' || !element.matches || !element.matches('[data-yml-track], [data-pm-main-wrap], [data-fc-track], .bs-gallery')) return;
    var parent = element.closest(componentSelector);
    if (!parent || element.scrollWidth <= element.clientWidth) return;
    var depth = Math.round(Math.abs(element.scrollLeft) / (element.scrollWidth - element.clientWidth) * 100);
    var previous = scrollStates.get(element) || 0;
    if (depth - previous < 10 && !(depth >= 95 && previous < 95)) return;
    scrollStates.set(element, depth);
    api.emit('component_interaction', Object.assign(fields(parent), { action: 'horizontal_scroll', interaction_type: 'scroll', horizontal_scroll_depth: Math.min(100, depth) }));
  }, true);
  document.addEventListener('visibilitychange', function () {
    states.forEach(function (state) { if (document.visibilityState === 'hidden') end(state, 'hidden'); else start(state); });
    accordions.forEach(function (state, element) { if (document.visibilityState === 'hidden') endAccordion(element, state, 'hidden'); else if (element.open) state.start = performance.now(); });
  });
  window.addEventListener('pagehide', function () { states.forEach(function (state) { end(state, 'pagehide'); }); accordions.forEach(function (state, element) { endAccordion(element, state, 'pagehide'); }); });
  window.addEventListener('pageshow', function () { states.forEach(start); });
  function resetPage(allowed) {
    accordions.clear(); scrollStates = new WeakMap();
    states.forEach(function (state) {
      state.started = null; state.impression = null; state.segment = 0;
      if (allowed) start(state);
    });
  }
  api.onConsent(resetPage);
  if (api.onPageView) api.onPageView(function () { resetPage(api.isAllowed()); });
  document.addEventListener('click', function (event) {
    var element = event.target.closest && event.target.closest('[data-ph-component][data-ph-action]');
    if (!element) return;
    var payload = Object.assign(fields(element), {
      action: element.getAttribute('data-ph-action'),
      interaction_type: 'click', content_name: element.getAttribute('data-ph-content-name') || 'unspecified'
    });
    if (element.matches('a[href]')) {
      try { var url = new URL(element.href, location.origin); if (/^https?:$/.test(url.protocol)) payload.destination_path = url.pathname; } catch (_) {}
    }
    api.emit('component_interaction', payload);
  });
  scan();
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () { scheduled = false; scan(); });
  }).observe(document.body, { childList: true, subtree: true, attributes: true,
    attributeFilter: ['class', 'style', 'hidden', 'inert', 'aria-hidden', 'data-ga4-component', 'data-ga4-component-id', 'data-ga4-section-id', 'data-ga4-component-owner', 'data-ph-component', 'data-ph-component-id', 'data-ph-id', 'data-ph-action'] });
  if (api.registerModule) api.registerModule('components', function () {
    var visible = 0, active = 0;
    states.forEach(function (state) { if (state.visible) visible++; if (state.started !== null) active++; });
    return { marked: document.querySelectorAll(componentSelector).length,
      independentMarked: document.querySelectorAll('[data-ga4-component]').length,
      observed: states.size, visible: visible, activeDwell: active,
      waitingForExposure: states.size - visible,
      clickable: document.querySelectorAll('[data-ph-component][data-ph-action]').length,
      observerAvailable: !!observer };
  });
})();
